import { useCallback, useState } from 'react';

import { confirmDialog, ConfirmDialogType } from '/common/ConfirmDialog';

import { RecoveryCodes } from './RecoveryCodes';
import { StyledDialog } from './styles';

export const useRecoveryCodes = () => {
  const [codes, setCodes] = useState<string[]>([]);

  const handleOpen = useCallback((newCodes: string[]) => {
    setCodes(newCodes);
  }, []);

  const onClose = () => {
    setCodes([]);
  };

  const handleClose = () => {
    confirmDialog({
      type: ConfirmDialogType.Warning,
      title: 'CLOSE RECOVERY CODES',
      content: 'Please make sure you saved recovery codes. It is the only way to login if you lose MFA device.',
      onSuccess: onClose,
    });
  };

  const node = (
    <StyledDialog size={300} open={codes.length > 0} onClose={handleClose}>
      <RecoveryCodes codes={codes} />
    </StyledDialog>
  );

  return [node, handleOpen] as const;
};
